export default "__VITE_ASSET__lfTiNTXc__"